import { DAILY, HOURLY, WEEKLY } from '../models/resolution';
import dayjs from 'dayjs';

const getResolution = (toDay, fromDay, resolution) => {
  const toDayDate = dayjs(toDay);
  const fromDayDate = dayjs(fromDay);
  const diffDays = toDayDate.diff(fromDayDate, 'day');
  const diffMonths = toDayDate.diff(fromDayDate, 'month');

  if (resolution === HOURLY) {
    if (diffDays > 3) {
      resolution = DAILY;
      if (diffMonths > 2) {
        resolution = WEEKLY;
      }
    }
  }

  return resolution;
};

const dayDiffResolution = (fromDay, toDay) => {
  const toDayDate = dayjs(toDay);
  const fromDayDate = dayjs(fromDay);

  return toDayDate.diff(fromDayDate, 'day');
};

const hasHourlyResolution = (fromDay, toDay) => {
  return dayDiffResolution(fromDay, toDay) < 3;
};

export { getResolution, hasHourlyResolution, dayDiffResolution };
